import React from "react";
import "../../../css/DesignSystem/Buttons/Buttons.css";

class ButtonGreen extends React.Component {
  constructor() {
    super();

    this.state = {
      clicked: false,
      greenClicked: false,
    };
  }

  render() {
    const { buttonText, onClick } = this.props;
    return (
      <div
        className={`Button-Brand2 ${this.state.greenClicked ? "clicked" : ""}`}
        onClick={() => {
          this.setState({ clicked: !this.state.clicked });
          onClick(); // Call the onClick prop function
        }}
      >
        <div className="Button-Text">{buttonText}</div>
      </div>
    );
  }
}

export default ButtonGreen;
